import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from './icons';
import type { RGB } from '../types';
import { rgbToHex } from '../utils/colors';
import { generateThemedPalettes } from '../utils/paletteGenerator';

interface ThemesEntryCardProps {
  color: RGB;
}

const ThemesEntryCard: React.FC<ThemesEntryCardProps> = ({ color }) => {
  const hex = rgbToHex(color.r, color.g, color.b).replace('#', '');

  const previewPalettes = useMemo(() => {
    const themes = generateThemedPalettes(color);
    return themes.slice(0, 5).map(theme => ({
      name: theme.name,
      colors: theme.palettes[0].colors.slice(0, 5),
    }));
  }, [color.r, color.g, color.b]);

  return (
    <Link
      to={`/themes/${hex}`}
      className="ui-panel block p-4 md:p-6 hover:border-brand-300 hover:shadow-md transition-all group"
    >
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-lg font-bold text-ink">Theme Palettes</h2>
        <div className="flex items-center gap-1 text-sm text-brand-600 group-hover:translate-x-1 transition-transform">
          <span>Explore 20+ themes</span>
          <ArrowRight size={16} />
        </div>
      </div>

      <div className="flex gap-2">
        {previewPalettes.map((theme) => (
          <div key={theme.name} className="flex-1 min-w-0">
            <div className="flex h-8 rounded-md overflow-hidden">
              {theme.colors.map((c, i) => (
                <div
                  key={i}
                  className="flex-1"
                  style={{ backgroundColor: c }}
                />
              ))}
            </div>
            <p className="text-xs text-ink-secondary mt-1 truncate text-center">
              {theme.name}
            </p>
          </div>
        ))}
      </div>
    </Link>
  );
};

export default ThemesEntryCard;
